import { useLocale } from '@/hooks';

export const usePlayUrl = (entryMapHashId: string) => {
  const { locale } = useLocale();

  const playUrl = `${process.env.NEXT_PUBLIC_BASE_URL}${
    locale === 'ko' ? '' : `/${locale}`
  }/play/${entryMapHashId}`;

  return playUrl;
};
